import React, { useState } from 'react'
import { useStyles } from './CloudPartnerDetailsWrapper.styles'
import { BoxV2, ExternalLink } from '@labrav/react-components'
import { HelpDrawer } from '@labrav/common'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlay } from '@fortawesome/free-solid-svg-icons'
import CloudDetails from '../../../common/images/CloudDetails.png'
import WhatAreYouDoingHereData from '../../../mocks/whatAreYouDoingHere.json'
import { VideoModal } from '../../../common/components/ProductVideoAction/VideoModal'
import { FormikProps, useFormikContext } from 'formik'
import { FlyOutListingData } from '../../../types/flyout'
import { AccountConfiguration } from '../AccountConfiguration/AccountConfiguration'
import {
  CreateStacksStepStatusIcon,
  CreateStacksSectionActions,
} from '../FlyOutArnAndDataFeedsWrapper/CreateStacksStepStatusIcon/CreateStacksStepStatusIcon'
import { Typography } from '@mui/material'

export type FlyOutCloudSettingsProps = {
  children: JSX.Element
  expandBox?: boolean
}

export const CloudPartnerDetailsWrapper: React.FC<FlyOutCloudSettingsProps> = ({
  children,
  expandBox = false,
}) => {
  const { classes } = useStyles()

  const [isVideoOpen, setIsVideoOpen] = useState(false)
  const handleThumnailClick = () => {
    setIsVideoOpen(true)
  }
  const formik = useFormikContext() as FormikProps<FlyOutListingData>

  return (
    <BoxV2
      data-testid="cloud-partner-details-section-box"
      heading="AWS account details"
      headingIcon={
        <div className={classes.stepHeading}>
          <CreateStacksStepStatusIcon section="cloudPartnerDetails" />
          <Typography className={classes.stepLabel}>STEP 01</Typography>
        </div>
      }
      variant="small"
      headingVariant="small"
      collapsible
      display={{ open: !!expandBox }}
      closedSecondaryActions={true}
      actions={<CreateStacksSectionActions />}
      secondaryActions={
        <HelpDrawer
          sectionName="flyOutCloudPartnerDetails"
          headerTitle="Help"
        />
      }
    >
      <>
        <div className={classes.content}>
          {children}
          <div
            className={classes.verticalDivider}
            data-testid="vertical-divider"
          ></div>
          <div className={classes.videoWrapper}>
            <div
              className={classes.videoContainer}
              data-testid="video-cloud-settings-details"
            >
              <img
                className={classes.thumbnailImages}
                src={CloudDetails}
                title="Labra FlyOut"
                alt={'cloud-settings'}
                onClick={handleThumnailClick}
              />
              <button
                type="button"
                className={classes.playButton}
                onClick={handleThumnailClick}
                aria-label="Play video"
              >
                <FontAwesomeIcon
                  icon={faPlay}
                  className={classes.playIcon}
                  style={{ height: '25px', width: '19px' }}
                />
              </button>
            </div>
            <div data-testid="video-link-cloud-settings">
              <ExternalLink
                href={WhatAreYouDoingHereData.cloudSettingPartnerDetails.video}
              >
                {WhatAreYouDoingHereData.cloudSettingPartnerDetails.linkText}
              </ExternalLink>
            </div>
          </div>
        </div>
        <AccountConfiguration
          sectionName="cloudSettings"
          isFormLocked={false}
          formik={formik}
        />
        <VideoModal
          actionTitle="AWS account details"
          actionLable=""
          isVideoModalOpen={isVideoOpen}
          setIsVideoModalOpen={setIsVideoOpen}
          videoLink={WhatAreYouDoingHereData.cloudSettingPartnerDetails.video}
        />
      </>
    </BoxV2>
  )
}
